/* Seelaz motion system (28-9). Deferred, no deps. Input first, visuals in rAF.
   Transform/opacity only. Tiered prefers-reduced-motion. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  if (window.szMotion) return;
  window.szMotion = 1;
  html.classList.add('sz-js'); /* hidden-initial states exist only under .sz-js */
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var AR = (html.lang || '').indexOf('ar') === 0;
  var EASE_IN = 'cubic-bezier(.22,1,.36,1)';
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  function reduced() { return RM.matches; }
  function t(ar, en) { return AR ? ar : en; }
  /* Web Animations helper: rise (translate+fade) or fade-only when reduced. */
  function rise(el, px, dur, delay) {
    if (!el || !el.animate) return;
    var r = reduced();
    el.animate(r ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 0, transform: 'translateY(' + px + 'px)' }, { opacity: 1, transform: 'none' }],
      { duration: r ? 120 : dur, delay: r ? 0 : (delay || 0), easing: EASE_IN, fill: 'backwards' });
  }

  /* ---------- Toast (single aria-live region) ---------- */
  var toastEl, toastTimer;
  function toast(msg, ms) {
    if (!toastEl) {
      toastEl = d.createElement('div');
      toastEl.className = 'sz-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      d.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    clearTimeout(toastTimer);
    raf(function () { toastEl.classList.add('is-in'); });
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-in'); }, ms || 2600);
  }
  window.szToast = toast;

  /* ---------- Add-to-cart state machine ---------- */
  var SEL = '[data-atc-form],[data-action-atc],#sz-atc__btn';
  var CHECK = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var job = null; /* {btns:[], vid, ok, t0} */

  function setState(btns, s) {
    for (var i = 0; i < btns.length; i++) {
      if (s) btns[i].setAttribute('data-sz-state', s); else btns[i].removeAttribute('data-sz-state');
    }
  }
  function ensureOk(b) {
    if (b.querySelector('.sz-atc-ok')) return;
    var s = d.createElement('span');
    s.className = 'sz-atc-ok';
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML = CHECK + '<span>' + t('اتضافت', 'Added') + '</span>';
    b.appendChild(s);
  }
  function mainBtn(b) {
    if (b.hasAttribute('data-atc-form')) return b;
    var m = d.querySelector('.t4s-product-form__submit[data-atc-form]');
    return m || b;
  }
  function start(b) {
    var m = mainBtn(b), btns = m === b ? [b] : [b, m];
    var f = m.closest ? m.closest('form') : null;
    var idEl = f && f.querySelector('[name="id"]');
    job = { btns: btns, vid: (idEl && idEl.value) || b.getAttribute('data-variant-id') || '', ok: false, seen: false, t0: Date.now() };
    setState(btns, 'loading');
    var j = job;
    /* Theme never started a request (validation / sold out): release quickly. */
    setTimeout(function () {
      if (job === j && !j.seen && !m.classList.contains('is--loading')) end(j, false);
    }, 900);
    setTimeout(function () { if (job === j) end(j, false); }, 15000);
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        if (m.classList.contains('is--loading')) { if (!j.seen) fly(b); j.seen = true; return; }
        if (j.seen) { mo.disconnect(); end(j, j.ok); }
      });
      mo.observe(m, { attributes: true, attributeFilter: ['class'] });
      j.mo = mo;
    }
  }
  function end(j, ok) {
    if (job !== j) return;
    job = null;
    if (j.mo) j.mo.disconnect();
    if (!ok) { setState(j.btns, ''); return; }
    raf(function () {
      for (var i = 0; i < j.btns.length; i++) ensureOk(j.btns[i]);
      setState(j.btns, 'added');
      setTimeout(function () { setState(j.btns, ''); }, 1500);
    });
    if (!reduced() && navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
    rewardDrawer(j.vid);
  }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!b) return;
    var s = b.getAttribute('data-sz-state');
    if (s === 'loading' && e.isTrusted !== false) { e.preventDefault(); e.stopImmediatePropagation(); return; } /* double-tap guard */
    if (job || b.disabled || b.getAttribute('aria-disabled') === 'true' || b.getAttribute('disabled') != null) return;
    start(b);
  }, true);
  /* Theme dispatches a native cart:updated after a successful render. */
  d.addEventListener('cart:updated', function () {
    if (job) job.ok = true;
    else if (okRow) okRow.hidden = true; /* qty change / remove: the "added" note no longer applies */
    syncShipNote();
  });
  /* Shipping note: bundle/offer prices include shipping, so show it only when a non-bundle item is in the cart. */
  function syncShipNote() {
    var dr = d.getElementById('t4s-mini_cart'), p = dr && dr.querySelector('[data-sz-ship]');
    if (!p) return;
    var ids = p.getAttribute('data-sz-ship') || ',', show = false;
    Array.prototype.forEach.call(dr.querySelectorAll('[data-cart-item][data-pid]'), function (it) {
      if (ids.indexOf(',' + it.getAttribute('data-pid') + ',') < 0) show = true;
    });
    p.hidden = !show;
  }

  /* ---------- Cart drawer reward moment ---------- */
  var okRow;
  function drawer() { return d.getElementById('t4s-mini_cart'); }
  function rewardDrawer(vid) {
    var tries = 0;
    (function wait() {
      var dr = drawer();
      var open = dr && dr.getAttribute('aria-hidden') === 'false';
      if (!open && tries++ < 12) { setTimeout(wait, 50); return; }
      var line = dr && vid ? dr.querySelector('.cart_item_' + vid) : null;
      var title = line && line.querySelector('.t4s-mini_cart__title');
      var name = title ? title.textContent.trim() : '';
      if (!open) { toast(t('اتضافت للسلة', 'Added to cart') + (name ? ': ' + name : '')); return; }
      raf(function () {
        var sc = dr.querySelector('[data-t4s-scroll-me]') || dr.querySelector('.t4s-drawer__scroll');
        if (sc) {
          if (!okRow) {
            okRow = d.createElement('div');
            okRow.className = 'sz-cart-ok';
            okRow.setAttribute('role', 'status');
          }
          okRow.innerHTML = CHECK + '<span>' + t('اتضافت للسلة', 'Added to cart') + (name ? ': <b></b>' : '') + '</span>';
          if (name) okRow.querySelector('b').textContent = name;
          if (okRow.parentNode !== sc) sc.insertBefore(okRow, sc.firstChild);
          okRow.hidden = false;
          rise(okRow, -8, 240, 120);
        }
        if (line) rise(line, 12, 420, 180);
      });
    })();
  }
  /* Hide the success row once the drawer closes. */
  if (window.MutationObserver) {
    var dr0 = drawer();
    if (dr0) new MutationObserver(function () {
      if (okRow && dr0.getAttribute('aria-hidden') === 'true') okRow.hidden = true;
    }).observe(dr0, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  /* ---------- Price crossfade on variant change (PDP) ---------- */
  function watchPrice() {
    if (!window.MutationObserver) return;
    var els = d.querySelectorAll('.t4s-product__info-container [data-product-price], .t4s-product__info-wrapper [data-product-price]');
    Array.prototype.forEach.call(els, function (el) {
      var last = el.textContent, busy = false;
      new MutationObserver(function () {
        if (busy) return;
        busy = true;
        raf(function () {
          busy = false;
          var now = el.textContent;
          if (now === last) return;
          last = now;
          if (el.animate) el.animate(reduced() ? [{ opacity: .4 }, { opacity: 1 }] : [{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }],
            { duration: reduced() ? 120 : 240, easing: EASE_IN });
        });
      }).observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  /* ---------- Hero slideshow: no autoplay under reduced motion ---------- */
  function heroCalm() {
    if (!reduced() || !window.jQuery_T4NT) return;
    Array.prototype.forEach.call(d.querySelectorAll('.t4s-slideshow.flickityt4s'), function (el) {
      try { var f = window.jQuery_T4NT(el).data('flickityt4s'); if (f && f.stopPlayer) f.stopPlayer(); } catch (e) {}
    });
  }

  /* ================= Signature layer ================= */
  var IO = 'IntersectionObserver' in window;
  function each(sel, fn, root) { Array.prototype.forEach.call((root || d).querySelectorAll(sel), fn); }
  function visible(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth ? r : null; }

  /* Fly-to-cart: image arcs to whichever cart icon is on screen (header or bottom toolbar; RTL read from DOM). */
  function fly(btn) {
    if (reduced() || !d.body.animate) return;
    raf(function () {
      var card = btn.closest('.t4s-product');
      var img = (card && card.querySelector('.t4s-product-img img')) ||
        d.querySelector('[data-main-media] .is-selected img, [data-main-media] img, .t4s-product__media-wrapper img');
      var icon = null;
      each('[data-cart-count]', function (c) { var p = c.parentElement; if (!icon && p && visible(p)) icon = p; });
      var hdr = d.querySelector('[data-cart-count]');
      if (!icon && hdr) icon = hdr.parentElement; /* header scrolled away: fly toward it (top edge) */
      if (!img || !icon) return;
      var a = visible(img) || btn.getBoundingClientRect(), b = icon.getBoundingClientRect();
      if (b.top < 8 || b.top > innerHeight) b = { left: b.left, width: b.width, top: 8, height: 0 };
      var S = 72, sx = a.left + a.width / 2 - S / 2, sy = a.top + a.height / 2 - S / 2;
      var ex = b.left + b.width / 2 - S / 2, ey = b.top + b.height / 2 - S / 2;
      var mx = (sx + ex) / 2, my = Math.min(sy, ey) - 90;
      var c = d.createElement('img');
      c.src = img.currentSrc || img.src; c.alt = ''; c.className = 'sz-fly';
      d.body.appendChild(c);
      var an = c.animate([
        { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(1.15)', opacity: 0 },
        { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(1)', opacity: 1, offset: .12 },
        { transform: 'translate(' + mx + 'px,' + my + 'px) scale(.75)', offset: .55 },
        { transform: 'translate(' + ex + 'px,' + ey + 'px) scale(.22)', opacity: .7 }
      ], { duration: 650, easing: 'cubic-bezier(.45,0,.2,1)' });
      an.onfinish = function () {
        c.remove();
        icon.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(1)' }], { duration: 380, easing: EASE_IN });
        var badge = icon.querySelector('[data-cart-count]');
        if (badge) badge.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.45)' }, { transform: 'scale(1)' }], { duration: 420, delay: 80, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      };
    });
  }

  /* Soft terracotta ripple on primary buttons (contained, never blocks input). */
  d.addEventListener('pointerdown', function (e) {
    if (reduced()) return;
    var b = e.target.closest && e.target.closest('.t4s-btn,.t4s-sticky-atc__atc,.sz-atc__btn');
    if (!b) return;
    raf(function () {
      var r = b.getBoundingClientRect(), s = Math.max(r.width, r.height) * 2.2, x = e.clientX - r.left - s / 2, y = e.clientY - r.top - s / 2;
      var sp = d.createElement('span');
      sp.className = 'sz-ripple';
      sp.style.cssText = 'width:' + s + 'px;height:' + s + 'px;left:' + x + 'px;top:' + y + 'px';
      b.appendChild(sp);
      var an = sp.animate([{ transform: 'scale(0)', opacity: .32 }, { transform: 'scale(1)', opacity: 0 }], { duration: 560, easing: 'cubic-bezier(.22,1,.36,1)' });
      an.onfinish = function () { sp.remove(); };
    });
  }, { passive: true });

  /* Word-by-word heading reveal (split on spaces only: Arabic letters stay joined). */
  var ioHead = IO && new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('sz-in'); ioHead.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  function splitHeadings(root) {
    each('.t4s-section-title > span', function (el) {
      if (el.hasAttribute('data-sz-split') || el.children.length) return;
      var words = el.textContent.trim().split(/\s+/);
      if (!words[0]) return;
      el.setAttribute('data-sz-split', '');
      el.innerHTML = '';
      words.forEach(function (w, i) {
        var s = d.createElement('span'); s.className = 'sz-w';
        s.style.setProperty('--i', i); s.textContent = w;
        el.appendChild(s); if (i < words.length - 1) el.appendChild(d.createTextNode(' '));
      });
      ioHead.observe(el);
    }, root);
  }

  /* Product cards: clip-path unveil + image settle, then text; 60ms stagger per batch, once. */
  var ioCard = IO && new IntersectionObserver(function (es) {
    var n = 0;
    es.forEach(function (en) {
      if (!en.isIntersecting) return;
      var c = en.target; ioCard.unobserve(c);
      c.style.setProperty('--sz-d', (n++ * 60) + 'ms');
      c.classList.add('sz-card-in');
      setTimeout(function () { c.classList.remove('sz-card', 'sz-card-in'); c.style.removeProperty('--sz-d'); }, 1400 + n * 60);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: .12 });
  function cards(root) {
    each('.t4s-product:not([data-sz-card])', function (c) {
      c.setAttribute('data-sz-card', '');
      if (!c.querySelector('.t4s-product-img') || c.closest('#t4s-mini_cart')) return;
      var w = c.closest('[hdt-reveal]') || c.querySelector('[hdt-reveal]');
      if (w) w.removeAttribute('hdt-reveal'); /* replaces the old slide-in for cards */
      c.classList.add('sz-card');
      ioCard.observe(c);
    }, root);
  }

  /* Product page entrance: media settles, info column staggers (transform/opacity; no layout change). */
  function pdpEntrance() {
    var media = d.querySelector('.t4s-product__media-wrapper'), info = d.querySelector('.t4s-product__info-wrapper');
    if (!media || !info || !media.animate || scrollY > 120) return;
    media.animate([{ opacity: .55, transform: 'scale(1.035)' }, { opacity: 1, transform: 'none' }], { duration: 520, easing: EASE_IN });
    var k = 0;
    each('.t4s-product__title,.t4s-product__price-review,.t4s-product__description', function (el) {
      el.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 440, delay: 80 + 70 * k++, easing: EASE_IN, fill: 'backwards' });
    }, info);
  }

  /* Hero: Ken Burns runs in CSS on the selected slide; after the first paint, slide changes also unveil. */
  function heroLive() { each('.t4s-slideshow', function (s) { s.classList.add('sz-hero-live'); }); }

  function wow() {
    if (reduced() || !IO) return;
    splitHeadings();
    cards();
    pdpEntrance();
    setTimeout(heroLive, 2500);
    /* cards/headings injected later (recommendations, recently viewed, quick shop).
       Only scan the element subtrees that were actually added, batched and run when idle,
       so app/cart DOM churn (cart polling, option widgets) costs almost nothing. */
    if (window.MutationObserver) {
      var roots = [], pend = false, SKIP = /^(SCRIPT|STYLE|LINK|META|NOSCRIPT|IFRAME|IMG|svg|SVG|PATH|TEMPLATE|INPUT|OPTION|BR)$/;
      var idle = window.requestIdleCallback ? function (f) { requestIdleCallback(f, { timeout: 600 }); } : function (f) { setTimeout(f, 300); };
      var flush = function () {
        pend = false;
        var list = roots; roots = [];
        if (list.length > 40) { splitHeadings(); cards(); return; }
        for (var i = 0; i < list.length; i++) {
          var r = list[i];
          if (!r.isConnected) continue;
          if (r.matches('.t4s-section-title > span')) splitHeadings(r.parentNode);
          else if (r.querySelector('.t4s-section-title > span')) splitHeadings(r);
          if (r.matches('.t4s-product:not([data-sz-card])')) cards(r.parentNode);
          else if (r.querySelector('.t4s-product:not([data-sz-card])')) cards(r);
        }
      };
      new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          var a = recs[i].addedNodes;
          for (var j = 0; j < a.length; j++) {
            var n = a[j];
            if (n.nodeType === 1 && !SKIP.test(n.nodeName) && n.firstElementChild !== undefined) roots.push(n);
          }
        }
        if (roots.length && !pend) { pend = true; setTimeout(function () { idle(flush); }, 250); }
      }).observe(d.body, { childList: true, subtree: true });
    }
  }
  wow(); /* deferred script: runs before DOMContentLoaded, so the old reveal never grabs the cards */

  function init() {
    watchPrice();
    heroCalm();
  }
  if (d.readyState === 'complete') init(); else window.addEventListener('load', init);
})();
